<template>
    <div>
        <!-- Modal -->
        <div class="modal fade" id="copiarModal" tabindex="-1" role="dialog" aria-labelledby="modelTitleId" aria-hidden="true">
            <div class="modal-dialog modal-dialog-scrollable modal-xl" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">Copiar / Selecione</h5>
                            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                                <span aria-hidden="true">&times;</span>
                            </button>
                    </div>
                    <div class="modal-body">
                        <div class="row">
                            <div class="col col-12 col-md-6">
                                <p>O que</p>
                                <div class="list-group">
                                    <button type="button" class="list-group-item list-group-item-action"
                                        :class="item.selecionado ? 'active' : ''"
                                        v-for="(item, idx) in lista_origem" :key="idx"
                                        @click="item.selecionado = !item.selecionado">
                                        {{ item.search }}
                                    </button>
                                </div>
                            </div>

                            <div class="col col-12 col-md-6">
                                <p>Para</p>
                                <div class="list-group" v-if="lista_destinos">
                                    <button type="button" class="list-group-item list-group-item-action"
                                        :class="destino.selecionado ? 'active' : ''" v-for="(destino, idx) in lista_destinos" :key="idx"
                                        @click="destino.selecionado = !destino.selecionado">
                                        {{ destino.search }} 
                                    </button>
                                </div>
                            </div>
                        </div>

                        <template v-if="false">

                            <p>
                                {{ id }} / {{ chave }}
                            </p>

                            <pre v-if="1 == 1">{{ lista_destinos }}</pre>

                        </template>

                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" data-dismiss="modal">Fechar</button>
                        <az-submit @click="atualizar()">Copiar</az-submit>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import _ from 'lodash';
import $ from 'jquery';
import AzSubmit from '../../util/AzSubmit.vue';

export default {
    data () { 
        return { 
            lista_origem: null, 
            lista_destinos: null, 
            validate: false, 
        }
    },

    components: { 
        AzSubmit,
    },

    props: ['lista', 'destinos', 'id', 'chave', 'service'],

    methods: { 
        copiar() { 
            let temp = _.cloneDeep(this.destinos);
            this.lista_destinos = temp.filter(item => item[this.chave] != this.id)
                .map(item => { 
                    item.selecionado = false;
                    return item;
                });

            this.lista_origem = _.map(
                _.cloneDeep(this.lista), 
                item => { 
                    item.selecionado = false;
                    return item;
                }
            );

            $('#copiarModal').modal('show');
        },

        atualizar() { 
            let origem = this.lista_origem.filter(item => item.selecionado);
            let destino = this.lista_destinos.filter(item => item.selecionado)
                .map(item => item[this.chave]);

            if ( !origem.length ) { 
                this.$toast.add({
                    severity: "error",
                    summary: "Atenção",
                    detail: "Selecione o que deseja copiar na coluna da esquerda.",
                    life: 3000
                });

                return;
            }

            if ( !destino.length ) { 
                this.$toast.add({
                    severity: "error",
                    summary: "Atenção",
                    detail: "Selecione para quem deseja copiar na coluna da direita.",
                    life: 3000
                });

                return;
            }

            this.$util.atualizar(this, { 
                service: this.service, 
                func: 'copiar', 
                dados: { 
                    origem: origem,
                    destino: destino, 
                },
                modal: 'copiarModal',
                toast: true, 
            });

        }
    }
}
</script>